class ReadingTime {
  static setTime(bookKey, time) {
    let json = localStorage.getItem("readingTime");
    let obj = JSON.parse(json) || {};
    obj[bookKey] = time;
    localStorage.setItem("readingTime", JSON.stringify(obj));
  }

  static getTime(bookKey) {
    let json = localStorage.getItem("readingTime");
    let obj = JSON.parse(json) || {};
    return obj[bookKey] || 0;
  }
  static getAllTime() {
    let json = localStorage.getItem("readingTime");
    let obj = JSON.parse(json) || {};
    return obj || [];
  }
  static clearTime(bookKey) {
    let json = localStorage.getItem("readingTime");
    let obj = JSON.parse(json) || {};
    delete obj[bookKey];
    localStorage.setItem("readingTime", JSON.stringify(obj));
  }
}

export default ReadingTime;
